import { AuthOperationType } from '../../server/middlewares/ssos/utils/sso.utils.js'

export const convertRedirectParamsToPath = (redirect: string) => {
  const sanitizedUri = sanitizeAndDecodeUri(redirect)

  return sanitizedUri
}

const sanitizeAndDecodeUri = (uri: string) => {
  if (!uri) {
    return '/'
  }

  const decodedUri = decodeURIComponent(uri)

  /**
   * Normalize backslashes to forward slashes to prevent bypass
   * (browsers treat /\evil.com as //evil.com)
   */
  const normalized = decodedUri.replace(/\\/g, '/')

  // Must start with a single slash (relative path only)
  if (!normalized.startsWith('/') || normalized.startsWith('//')) {
    return '/'
  }

  return normalized
}

export const getFailedAuthRedirectUri = (
  operation: AuthOperationType,
  redirectPath: string,
) => {
  const params = new URLSearchParams()

  if (redirectPath) {
    params.append('redirect', redirectPath)
  }

  if (operation === AuthOperationType.signup) {
    return getFailedSignupRedirectUri(params)
  }

  if (operation === AuthOperationType.login) {
    return getFailedLoginRedirectUri(params)
  }

  return undefined
}

const getFailedLoginRedirectUri = (optionalParams: URLSearchParams) => {
  const query = optionalParams.toString()
  return `/auth/login${query.length ? `?${query}` : ''}`
}

const getFailedSignupRedirectUri = (optionalParams: URLSearchParams) => {
  const query = optionalParams.toString()
  return `/auth/signup${query.length ? `?${query}` : ''}`
}

export const getRedirectParamsFromQuery = (
  query: Record<string, string>,
): string => {
  return query?.redirect ?? ''
}
